import { Component, Inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { DataService } from "../../dataService/data.service";


@Component({
  selector: "app-analytics-invite-click-through-rate",
  templateUrl: "./analytics-invite-click-through-rate.component.html",
  styleUrls: ["./analytics-invite-click-through-rate.component.scss"],
})
export class AnalyticsInviteClickThroughRateComponent implements OnInit {
  public loading = false;
  gaugeType = "full";
  gaugeValue = 55;
  gaugeLabel = "Received";
  gaugeAppendText = "";

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private HttpService: DataService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private toastrService: ToastrService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {}

  ngOnInit() {
    this.loading = true;
  }
}
